import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { sessionResolver } from './resolvers/session.resolver';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
    resolve: { session: sessionResolver },
  },
  {
    path: 'about-us',
    loadChildren: () => import('./pages/about-us/about-us.module').then(m => m.AboutUsModule),
    // resolve: { session: sessionResolver }
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./pages/contact-us/contact-us.module').then(m => m.ContactUsModule),
    // resolve: { session: sessionResolver }
  },
  {
    path: 'terms-of-use',
    loadChildren: () => import('./pages/terms-of-use/terms-of-use.module').then(m => m.TermsOfUseModule),
    // resolve: { session: sessionResolver }
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
    // resolve: { session: sessionResolver }
  },
  {
    path: 'cookie-policy',
    loadChildren: () => import('./pages/cookie-policy/cookie-policy.module').then(m => m.CookiePolicyModule),
    // resolve: { session: sessionResolver }
  },
  {
    path: 'offers',
    loadChildren: () => import('./pages/offers/offers.module').then(m => m.OffersModule),
    /*  resolve: { session: sessionResolver } */
  },
  { path: 'e-consent', loadChildren: () => import('./pages/e-consent/e-consent.module').then(m => m.EConsentModule) },
  {
    path: 'credit-authorization-agreement',
    loadChildren: () => import('./pages/credit-authorization-agreement/credit-authorization-agreement.module').then(m => m.CreditAuthorizationAgreementModule)
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    { preloadingStrategy: PreloadAllModules }
  )],
  exports: [RouterModule]
})

export class AppRoutingModule { }
